<h2 mat-dialog-title>Edit Finding</h2>
<mat-dialog-content>
  <iaud-finding-edit-form [finding]="finding" (isValidChange)="toggleFormValidity($event)"></iaud-finding-edit-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button
          [disabled]="!isFormValid"
          [color]="'accent'"
          (click)="update()">Update
  </button>
</mat-dialog-actions>
